import { LinkButton } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './RecommendedVillages.css';
import { VillageItem } from './components/VillageItem';
import { IRecommendedVillage } from '../../types/recommendedVillages';

interface IRecommendedVillagesProps {
  villageList: IRecommendedVillage[];
  onVillageClick: (id: number, position: number) => void;
  onShowAllClick(): void;
  link: string;
  ref?: React.Ref<HTMLDivElement>;
}

export function RecommendedVillagesNew({
  villageList,
  onVillageClick,
  onShowAllClick,
  link,
  ref,
}: IRecommendedVillagesProps) {
  return (
    <div ref={ref}>
      <div className={styles['villages-list']}>
        {villageList.map((village, index) => (
          <VillageItem {...village} key={village.id} onClick={() => onVillageClick(village.id, index + 1)} />
        ))}
      </div>
      <div className={styles['villages-button']}>
        <LinkButton size="XS" theme="fill_secondary" onClick={onShowAllClick} href={link} target="_blank">
          Смотреть все посёлки
        </LinkButton>
      </div>
    </div>
  );
}
